/**
 * @file feedbackApi.js
 * @description 客户端用户反馈 API（提交 / 分页 / 详情）
 * @module features/user/api/feedbackApi
 */

import axios from '@/shared/utils/axios'
import API from '@/config/api'
import { getAuthToken } from '@/shared/utils/auth'

/**
 * @typedef {Object} WebFeedbackSubmitReq
 * @property {'BUG'|'SUGGESTION'|string} type 反馈类型
 * @property {string} content 反馈正文（≤2000）
 */

/**
 * @typedef {Object} WebFeedbackPageItem
 * @property {string} feedbackId
 * @property {string} type
 * @property {string} typeName
 * @property {string} status
 * @property {string} statusName
 * @property {string} contentSummary
 * @property {string} submitTime
 * @property {boolean} [replied]
 */

/**
 * @typedef {Object} WebFeedbackDetail
 * @property {string} feedbackId
 * @property {string} type
 * @property {string} typeName
 * @property {string} status
 * @property {string} statusName
 * @property {string} content
 * @property {string} submitTime
 * @property {string} [replyContent]
 * @property {string} [replyTime]
 */

/**
 * 提交用户反馈
 * @param {WebFeedbackSubmitReq} payload
 * @returns {Promise<import('axios').AxiosResponse>}
 */
export async function submitFeedbackApi(payload) {
  const token = getAuthToken()
  return axios.post(API.FEEDBACK.SUBMIT, payload, {
    headers: { 'COMIC-WEB-TOKEN': token },
  })
}

/**
 * 我的反馈分页
 * @param {{ pageNum: number, pageSize: number }} params
 * @returns {Promise<import('axios').AxiosResponse>}
 */
export async function fetchFeedbackPageApi(params) {
  const token = getAuthToken()
  return axios.post(API.FEEDBACK.PAGE, params, {
    headers: { 'COMIC-WEB-TOKEN': token },
  })
}

/**
 * 反馈详情（本人）
 * @param {{ id: string }} payload OpenAPI IdReq
 * @returns {Promise<import('axios').AxiosResponse>}
 */
export async function fetchFeedbackDetailApi(payload) {
  const token = getAuthToken()
  return axios.post(API.FEEDBACK.DETAIL, payload, {
    headers: { 'COMIC-WEB-TOKEN': token },
  })
}
